import { ready } from '~/core';

const prodCompIcons = [];

ready('prodComp Table', '.prod-comp.swiper', (pcSwiper) => {
  const tableHeaders = pcSwiper.querySelector('.prod-comp-table__headers');
  const headerCards = pcSwiper.querySelectorAll('.prod-comp-header__card');
  const headerInner = pcSwiper.querySelector('.prod-comp-header__inner');
  const table = pcSwiper.querySelector('.prod-comp-table');
  const header = document.querySelector('header');

  if (tableHeaders)
    initTableHeaders();

  if (headerCards?.length)
    fetchIcons();

  if (headerInner)
    addIcons(headerInner);

  if (table) {
    const tableRows = table.querySelectorAll('.prod-comp-table__row');
    tableRows.forEach((row) => addIcons(row));
  }



  // -- Functions -- //

  // Init sticky headers
  function initTableHeaders() {
    let isSticky = false;

    function checkHeader() {
      requestAnimationFrame(checkHeader);

      const tableRect = pcSwiper.getBoundingClientRect();
      const headerRect = header.getBoundingClientRect();
      const headerStyle = getComputedStyle(header);

      if (tableRect.top - 200 <= headerRect.bottom && !isSticky) {
        tableHeaders.classList.add('sticky');
        isSticky = true;
      } else if (tableRect.top - 220 > headerRect.bottom && isSticky) {
        tableHeaders.classList.remove('sticky');
        isSticky = false;
      }

      pcSwiper.style.setProperty("--pc-table-offset", `${parseFloat(headerStyle.top) + parseFloat(headerRect.height)}px`);
    }

    requestAnimationFrame(checkHeader);
  }

  // Get icon urls from header cards
  function fetchIcons() {
    headerCards.forEach((card) => {
      const icon = card.querySelector('.prod-comp-header__card-icon');
      const iconSrc = icon?.getAttribute('src');

      if (iconSrc && !prodCompIcons.includes(iconSrc)) {
        prodCompIcons.push(iconSrc);
      }
    });
  }

  // Add to children modal links
  function addIcons(parentEl) {
    const children = parentEl.children;
    
    [...children].forEach((child, index) => {
      const modalLinks = child.querySelectorAll('.tru-dialog__open-link');
      const iconSrc = prodCompIcons[index];
      modalLinks.forEach((link) => {
        link.dataset.iconSrc = iconSrc;
      });
    })
  }
})


